import React from "react";
import {Badge, Button, Col, Drawer, Row, Table, Tag, Tooltip} from "antd";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {courierTypeMapping} from "../responsiveDataTable/ResponsiveDataTable";
import moment from "moment";
import {
    courierStatusColors,
    courierStatuses,
    mapCourierStatuses
} from "../../../../constants/constants";
import {getConstant, isConstantExist} from "../../../../utils/helpers";
import {useTranslation} from "react-i18next";

/* 
    Havuz kuryelerini gösteren drawer componenti
    type: kurye durumuna göre filtreleme yapmak için kullanılır 
    visible: drawerın açık olup olmadığını belirler
    onClose: drawerın kapatılmasını sağlar
*/

export const PoolCouriersDrawer = ({poolId, type, poolName = "", visible, onClose}) => {
    const stores = useStore();
    const {t} = useTranslation(["courierStatuses"]);
    const [loading, poolCouriers] = useFetch({
        fetchFn: stores.poolShiftStore.getPoolCouriersByState.bind(null, {
            poolId,
            courierType: type
        }),
        waitForResponse: true,
        dependencies: [poolId, type],
        condition: visible && poolId && type
    });

    return (
        <Drawer
            title={
                <b>
                    {poolName} - {courierTypeMapping?.[type]?.label}
                </b>
            }
            placement="right"
            closable={true}
            onClose={onClose}
            closeIcon={
                <Button
                    type="primary"
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: "11px",
                        right: "10px"
                    }}
                >
                    Kapat
                </Button>
            }
            visible={visible}
            width={"100%"}
        >
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Row>
                        <Table
                            loading={loading}
                            pagination={
                                false /* {
                                total: dataCount,
                                current: currentPage,
                                onChange: async page => {
                                    setCurrentPage(page);
                                },
                                hideOnSinglePage: true,
                                showSizeChanger: false
                            } */
                            }
                            rowKey="_id"
                            dataSource={poolCouriers?.data}
                            data-testid="poolDataTable"
                            size="small"
                            scroll={{x: "max-content"}}
                            style={{width: "100%"}}
                            //loading={loading}
                        >
                            <Table.Column
                                title="Kurye Adı"
                                dataIndex="name"
                                key="name"
                                sorter={(a, b) => a.name.localeCompare(b.name, "tr")}
                                defaultSortOrder={"ascend"}
                                render={(name,record) => <a  target="_blank" href ={`/couriers/${record.id}`}>{name}</a>}
                            />
                            <Table.Column title="Telefon" dataIndex="phone" key="phone" />
                            <Table.Column
                                title="Durum"
                                dataIndex="state"
                                key="state"
                                sorter={(a, b) => a.state.localeCompare(b.state, "tr")}
                                render={state => (
                                    <Tag data-testid="courierStatus">
                                        <Badge
                                            data-testid="courierStatus_badge"
                                            data-testvalue={Boolean(state)}
                                            color={courierStatusColors[state]}
                                        />
                                        {isConstantExist(courierStatuses, state)
                                            ? t(
                                                  getConstant(courierStatuses, state)
                                                      .translation_key,
                                                  {
                                                      ns: "courierStatuses"
                                                  }
                                              )
                                            : "-"}
                                    </Tag>
                                )}
                            />
                            <Table.Column
                                title="Durum Açıklaması"
                                dataIndex="stateReasonText"
                                key="stateReasonText"
                                ellipsis={{showTitle: false}}
                                render={stateReasonText => (
                                    <Tooltip placement="topLeft" title={stateReasonText}>
                                        <p
                                            style={{
                                                maxWidth: "150px",
                                                margin: 0,
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {stateReasonText}
                                        </p>
                                    </Tooltip>
                                )}
                            />
                            <Table.Column
                                title="Son Durum Tarihi"
                                dataIndex="lastStateDate"
                                key="lastStateDate"
                                sorter={(a, b) =>
                                    moment(a.lastStateDate).diff(moment(b.lastStateDate))
                                }
                                render={lastStateDate => (
                                    <>{moment(lastStateDate).format("DD.MM.YYYY HH:mm")}</>
                                )}
                            />
                        </Table>
                    </Row>
                </Col>
            </Row>
        </Drawer>
    );
};
